import { CALENDLY_URL } from "@/lib/data";

export function openCalendly() {
  if (typeof window !== "undefined" && window.Calendly) {
    window.Calendly.initPopupWidget({
      url: CALENDLY_URL,
      pageSettings: {
        backgroundColor: "0a0a0a",
        primaryColor: "c8ff5a",
        textColor: "ffffff",
        hideEventTypeDetails: false,
        hideLandingPageDetails: false,
      },
    });
    return false;
  }
  // Fallback if script hasn't loaded
  window.open(CALENDLY_URL, "_blank", "noopener,noreferrer");
  return false;
}
